import { Pipe, PipeTransform } from '@angular/core';

const PADDING = '000000';

@Pipe({
  name: 'CurrencyPipe',
})
export class CurrencyPipe implements PipeTransform {

  private DECIMAL_SEPARATOR: string;
  private THOUSANDS_SEPARATOR: string;

  constructor() {
    this.DECIMAL_SEPARATOR = '.';
    this.THOUSANDS_SEPARATOR = ',';
  }

  transform(value: string) {
    if (value && +value > 0) {
      let data = value ? value.toString() : '';
      data = data.split(',').join('');
      const result = data.split('.');
      let lastThree = result[0].substring(result[0].length - 3);
      let output = '';
      const otherNumbers = result[0].substring(0, result[0].length - 3);
      if (otherNumbers !== '') {
        lastThree = this.THOUSANDS_SEPARATOR + lastThree;
      }
      output = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, this.THOUSANDS_SEPARATOR) + lastThree;
      if (result.length > 1) {
        output += this.DECIMAL_SEPARATOR + result[1];
      }
      return output;
    } else {
      return value;
    }
  }

  parse(value: string, fractionSize: number = 0): string {
    let [integer, fraction = ''] = (value || '').split(this.DECIMAL_SEPARATOR);

    integer = integer.replace(new RegExp(this.THOUSANDS_SEPARATOR, 'g'), '');

    fraction = parseInt(fraction, 10) > 0 && fractionSize > 0
      ? this.DECIMAL_SEPARATOR + (fraction + PADDING).substring(0, fractionSize)
      : '';

    return integer + fraction;
  }
}
